import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardAvatar from "../../components/Card/CardAvatar.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardFooter from "../../components/Card/CardFooter.jsx";
import { spinnerService } from "@chevtek/react-spinners";
import imgPlaceholder from "../../assets/img/logo-placeholder.jpg";
import Icon from "@material-ui/core/Icon";
import Avatar from "@material-ui/core/Avatar";
import * as actionTypes from "../../redux/actions";
import _ from "lodash";
import { Link } from "react-router-dom";

import { toast } from "react-toastify";
import Input from "@material-ui/core/Input";
import { getCustomer } from "../../graphql/queries";
import gql from "graphql-tag";
import { Auth, API, graphqlOperation, Storage } from "aws-amplify";
import { withApollo } from "react-apollo";
import { flowRight } from "lodash";
import { connect } from "react-redux";
import Autocomplete from "react-google-autocomplete";
import { updateCustomer } from "../../graphql/mutations";
import { getCustomerTeam } from "../../graphql/queries";

Storage.configure({
  AWSS3: {
    bucket: "calbitwebappuploadbucket1254-dev", //Your bucket name;
    region: "us-east-2" //Specify the region your bucket was created in;
  }
});
const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardHeader: {
    backgroundColor: "#000000"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};
function TeamButtons({ value }) {
  if (value === "Vendors") {
    return (
      <div>
        {" "}
        <Button
          round
          component={Link}
          to={{
            pathname: "/profile/list/Mechanics"
          }}
          color="primary"
        >
          Mechanics
        </Button>
      </div>
    );
  } else if (value === "TireVendors") {
    return (
      <div>
        <Button
          round
          component={Link}
          to={{
            pathname: "/profile/list/TireMan"
          }}
          color="primary"
        >
          Tire Mans
        </Button>
      </div>
    );
  } else if (value === "Customers") {
    return (
      <div>
        <Button
          round
          component={Link}
          to={{
            pathname: "/profile/list/Dispatchers"
          }}
          color="primary"
        >
          View Dispatcher
        </Button>
      </div>
    );
  } else if (value === "Dispatchers") {
    return (
      <div>
        <Button
          round
          component={Link}
          to={{
            pathname: "/profile/list/Technicians"
          }}
          color="primary"
        >
          View Technicians
        </Button>
        <br />
        <Button
          round
          component={Link}
          to={{
            pathname: "/profile/list/Drivers"
          }}
          color="primary"
        >
          View Drivers
        </Button>
      </div>
    );
  }
}
function Headline({ value }) {
  return <h1>{value}</h1>;
}
class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: null,
      username: null,
      fName: null,
      lName: null,
      email: null,
      password: null,
      cPassword: null,
      address: null,
      city: "",
      state: "",
      phoneNo: null,
      zipCode: "",
      passwordValidate: true,
      phoneValidated: true,
      lat: "",
      lng: "",
      generalInstructions: "",
      faxNo: "",
      isPicChanged: false,
      picture: {},
      rawPicture: {},
      pictureObj: imgPlaceholder,
      uploadedPicKey: "",
      addressType: "",
      customerUsername: "",

      errors: {
        cognito: null,
        blankfield: false,
        passwordmatch: false
      },
      emailValidate: true,
      emailFeedback: null
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.uploadPic = this.uploadPic.bind(this);
  }
  clearErrorState = () => {
    this.setState({
      errors: {
        cognito: null,
        blankfield: false,
        passwordmatch: false
      }
    });
  };
  checkValidate = () => {
    let { passwordValidate, phoneValidated } = this.state;
    if (!passwordValidate) {
      document.getElementById("password").focus();
      return false;
    } else if (!phoneValidated) {
      document.getElementById("phoneNo").focus();
      return false;
    } else {
      return true;
    }
  };
  async handleSubmit() {
    spinnerService.show("mySpinner");

    const {
      company,
      username,
      fName,
      lName,
      email,
      address,
      city,
      state,
      phoneNo,
      zipCode,
      generalInstructions,
      pictureObj,
      picture,
      faxNo,
      isPicChanged,
      emailValidate,
      lat,
      lng
    } = this.state;
    let { client, user, profile } = this.props;
    let customerName = "";
    if (!(profile === undefined || profile === "" || profile === null)) {
      customerName = profile.id;
    } else customerName = this.state.customerUsername;

    try {
      let addr = {};
      let customerAddresses = [];

      if (!_.isEmpty(address)) addr.address = address;
      if (!_.isEmpty(city)) addr.city = city;
      if (!_.isEmpty(state)) addr.state = state;
      if (!_.isEmpty(zipCode)) addr.zipCode = zipCode;
      if (!_.isEmpty(phoneNo)) addr.phoneNo = phoneNo;
      if (!_.isEmpty(faxNo)) addr.faxNo = faxNo;
      if (lat !== "") addr.locationLat = lat;
      if (lng !== "") addr.locationLong = lng;

      addr.addressType = "PRIMARY";
      customerAddresses.push(addr);

      let input = {
        id: customerName,
        companyName: company
      };
      if (!_.isEmpty(fName)) input.customerFirstName = fName;
      if (!_.isEmpty(lName)) input.customerLastName = lName;
      if (!_.isEmpty(email)) input.email = email;
      if (!_.isEmpty(generalInstructions))
        input.generalInstructions = generalInstructions;
      if (customerAddresses.length > 0)
        input.customerAddresses = customerAddresses;

      if (isPicChanged) {
        let key = "";
        try {
          key = await Storage.put(
            new Date().getTime() + this.state.rawPicture.name,
            this.state.rawPicture
          );
        } catch (err) {
          "Image Upload Error", err;
        }
        this.setState({ uploadedPicKey: key.key });
      }
      let pic = {};
      let data = { ...input };
      if (this.state.uploadedPicKey !== "") {
        pic.key = this.state.uploadedPicKey;
        pic.bucket = "calbitwebappuploadbucket1254-dev";
        pic.region = "us-east-2";
        input.picture = pic;
        data.picture = pic;
      } else {
        if (this.state.pictureObj !== "" || this.state.pictureObj !== null)
          data.picture = this.state.picture;
      }
      var result = await API.graphql(
        graphqlOperation(updateCustomer, { input })
      );
      //update redux store with updated
      data.pictureObj = this.state.pictureObj;
      profile = { ...profile, ...data };
      this.props.updateProfile(profile);

      //clear all state
      this.setState({ open: false, uploadedPicKey: "", isPicChanged: false });

      spinnerService.hide("mySpinner");
      toast.success("Profile Updated!");
      "User Profile Updated", result;
      window.reload();
    } catch (err) {
      spinnerService.hide("mySpinner");
    }
  }
  async uploadPic() {
    let key = "";
    try {
      key = await Storage.put(
        new Date().getTime() + this.state.rawPicture.name,
        this.state.rawPicture
      );
    } catch (err) {
      "Image Upload Error", err;
    }
    this.setState({ uploadedPicKey: key.key });
  }
  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });

    // document.getElementById(event.target.id).classList.remove("is danger");
  };
  onPasswordChange = (e, otherPassword) => {
    e.currentTarget.type = "password";
    this.setState({ [e.target.id]: e.target.value });
    if (e.target.value !== otherPassword)
      this.setState({ passwordValidate: false });
    else this.setState({ passwordValidate: true });
  };
  onEmailChange = e => {
    let { value } = e.target;
    value = value.toLowerCase();
    this.setState({ email: value });
    if (/.+@.+\.[A-Za-z]+$/.test(value)) {
      Auth.signIn({ username: value, password: "123" })
        .then(res => {})
        .catch(err => {
          if (err.code !== "UserNotFoundException")
            this.setState({
              emailValidate: false,
              emailFeedback: "Email already exist!"
            });
          else this.setState({ emailValidate: true });
        });
    } else {
      this.setState({ emailValidate: false, emailFeedback: "" });
    }
  };
  onPhoneChange = e => {
    let { id, value } = e.target;
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (value.match(phoneno)) {
      this.setState({ [id]: value, phoneValidated: true });
    } else {
      this.setState({ [id]: value, phoneValidated: false });
    }
  };
  async componentDidMount() {
    spinnerService.show("mySpinner");
    const { client, user, profile } = this.props;
    let custUsername = user.username;
    let data = {};
    let isFetched = false;

    if (profile === undefined || profile === "" || profile === null) {
      let userType = null;
      if (
        user !== null &&
        user !== "notFound" &&
        user.signInUserSession.idToken.payload["cognito:groups"] !== undefined
      ) {
        userType = user.signInUserSession.idToken.payload["cognito:groups"][0];
      }
      if ((userType === "Dispatchers") | (userType === "Technicians")) {
        let custTeam = (await client.query({
          query: gql(getCustomerTeam),
          fetchPolicy: `network-only`,
          variables: { id: user.username }
        })).data.getCustomerTeam;

        custUsername = custTeam.customer.id;
      }
      const custProfile = await client.query({
        query: gql(getCustomer),
        fetchPolicy: `network-only`,
        variables: {
          id: custUsername
        }
      });
      data = custProfile.data.getCustomer;
      isFetched = true;
    } else data = profile;
    let stateObj = {
      company: data.companyName,
      fName: data.customerFirstName,
      lName: data.customerLastName,
      email: data.email,
      username: custUsername,
      picture: data.picture,
      generalInstructions: data.generalInstructions
    };
    if (data.customerAddresses.length > 0) {
      stateObj.address = data.customerAddresses[0].address;
      stateObj.city = data.customerAddresses[0].city;
      stateObj.state = data.customerAddresses[0].state;
      stateObj.phoneNo = data.customerAddresses[0].phoneNo;
      stateObj.faxNo = data.customerAddresses[0].faxNo;
      stateObj.locationLat = data.customerAddresses[0].locationLat;
      stateObj.locationLong = data.customerAddresses[0].locationLong;
      stateObj.zipCode = data.customerAddresses[0].zipCode;
    }
    this.setState(stateObj);
    this.setState({ customerUsername: custUsername });

    if (data.pictureObj === undefined || data.pictureObj === null) {
      let pic = data.picture;
      if (pic !== null) {
        if (pic !== undefined) {
          Storage.get(pic.key)
            .then(pictureObj => {
              this.setState({ pictureObj });
              data.pictureObj = pictureObj;
            })
            .catch(err => {});
        }
      }
    } else this.setState({ pictureObj: data.pictureObj });
    isFetched && this.props.storeProfile(data);
    spinnerService.hide("mySpinner");
  }

  render() {
    const { classes } = this.props;
    let userType = undefined;
    if (
      this.props.user !== null &&
      this.props.user !== "notFound" &&
      this.props.user.signInUserSession.idToken.payload["cognito:groups"] !==
        undefined
    ) {
      userType = this.props.user.signInUserSession.idToken.payload[
        "cognito:groups"
      ][0];
    }
    if (userType === undefined) {
      return (
        <div>
          <h2>User type not defined. Please login again</h2>
        </div>
      );
    }
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader className={classes.cardHeader}>
                <h4 className={classes.cardTitleWhite}>Edit Company Profile</h4>
                <p className={classes.cardCategoryWhite}>
                  Update company profile
                </p>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <Input
                      style={{ paddingTop: 5 }}
                      id="company"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="Company (disabled)"
                      type="text"
                      value={this.state.company}
                      required
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Input
                      style={{ paddingTop: 5 }}
                      id="username"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="Username"
                      type="text"
                      value={this.state.username}
                      required
                      disabled="true"
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <Input
                      style={{ paddingTop: 25 }}
                      id="fName"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="First Name"
                      type="text"
                      value={this.state.fName}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Input
                      style={{ paddingTop: 25 }}
                      id="lName"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="Last Name"
                      type="text"
                      value={this.state.lName}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <Autocomplete
                      style={{
                        width: "84%",
                        paddingTop: 25,
                        border: "none",
                        borderBottom: "1px solid grey",
                        fontSize: "medium",
                        color: "grey"
                      }}
                      id="address"
                      value={this.state.address}
                      onChange={this.onInputChange.bind(this)}
                      type="text"
                      onPlaceSelected={place => {
                        let stateObj = {};
                        var componentForm = {
                          street_number: "short_name",
                          route: "long_name",
                          locality: "long_name",
                          administrative_area_level_1: "short_name",
                          country: "long_name",
                          postal_code: "short_name"
                        };
                        let address = place.address_components;
                        address !== undefined &&
                          address.forEach(item => {
                            if (componentForm[item.types[0]]) {
                              if (item.types[0] === "locality")
                                stateObj.city = item.long_name;

                              if (
                                item.types[0] === "administrative_area_level_1"
                              )
                                stateObj.state = item.long_name;
                              if (item.types[0] === "postal_code")
                                stateObj.zipCode = item.long_name;
                            }
                          });
                        stateObj.address = place.formatted_address;
                        stateObj.lat = place.geometry.location.lat();
                        stateObj.lng = place.geometry.location.lng();
                        this.setState(stateObj);
                      }}
                      types={["address"]}
                      componentRestrictions={{ country: "us" }}
                      fields={[
                        "geometry",
                        "formatted_address",
                        "address_components"
                      ]}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Input
                      style={{ paddingTop: 25 }}
                      id="city"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="city"
                      type="text"
                      value={this.state.city}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Input
                      style={{ paddingTop: 25 }}
                      id="state"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="State"
                      type="text"
                      value={this.state.state}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Input
                      style={{ paddingTop: 25, width: "50%" }}
                      id="zipCode"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="Zip Code"
                      type="text"
                      value={this.state.zipCode}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Input
                      style={{ paddingTop: 25 }}
                      id="phoneNo"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="Phone"
                      type="text"
                      value={this.state.phoneNo}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Input
                      style={{ paddingTop: 25 }}
                      id="email"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="Email"
                      type="text"
                      value={this.state.email}
                      required
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <Input
                      style={{ paddingTop: 25, width: "84%" }}
                      id="generalInstructions"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="General Instructions"
                      type="text"
                      value={this.state.generalInstructions}
                    />
                  </GridItem>
                </GridContainer>
                <div style={{ float: "right", marginTop: 20 }}>
                  <Button
                    color="secondary"
                    onClick={() => this.props.history.push("/")}
                  >
                    Back
                  </Button>
                  <Button color="primary" onClick={() => this.handleSubmit()}>
                    Update Profile
                  </Button>
                </div>
              </CardBody>
              <CardFooter></CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card profile>
              <div>
                <CardAvatar profile style={{ width: 250, height: 250 }}>
                  <a
                    href="#pablo"
                    onClick={e => {
                      e.preventDefault();
                      document.getElementById("insp-pic").click();
                    }}
                  >
                    <img src={this.state.pictureObj} alt="..." />

                    <Icon
                      style={{
                        position: "absolute",
                        left: "55%",
                        right: "45%",
                        top: 55,
                        color: "black"
                      }}
                    >
                      camera_alt
                    </Icon>
                  </a>
                </CardAvatar>
              </div>

              <CardBody profile>
                {" "}
                <input
                  id="insp-pic"
                  onChange={e => {
                    this.setState({
                      pictureObj: URL.createObjectURL(e.target.files[0]),
                      rawPicture: e.target.files[0],
                      isPicChanged: true
                    });
                  }}
                  style={{ display: "none" }}
                  type="file"
                />
                <h6 className={classes.cardCategory}>
                  {this.state.company} Team Setup
                </h6>
                <TeamButtons value={userType} />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    profile: state.config.profile
  };
};
const mapDispatchToProps = dispatch => {
  return {
    storeProfile: data => dispatch(actionTypes.storeProfile(data)),
    updateProfile: data => dispatch(actionTypes.updateProfile(data))
  };
};
export default UserProfile = connect(
  mapStateToProps,
  mapDispatchToProps
)(flowRight(withApollo)(withStyles(styles)(UserProfile)));



// WEBPACK FOOTER //
// ./src/customers/profile/UserProfile.jsx